import cn from 'clsx'
import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'

// Components
import { Section } from '@tracklib/kit'
import { StreamField } from 'components/staticpages/streamfield'

import styles from './columnsblock.css'

const getAlignmentClassName = (alignment: number) => {
  if (+alignment === 0) {
    return styles.alignTop
  }
  if (+alignment === 2) {
    return styles.alignBottom
  }
  return null
}

type ColumnsBlockProps = {
  value: {
    columns: Array<
      Array<{
        type: string
        value: string
      }>
    >
    align_children: number
    parallax: boolean
  }
}

const ColumnsBlock = ({ value: { columns, align_children, parallax } }: ColumnsBlockProps): JSX.Element => {
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
    rootMargin: '-200px 0px',
  })
  return (
    <Section size="medium">
      <motion.div
        animate={inView ? 'visible' : 'hidden'}
        variants={{
          visible: { opacity: 1 },
          hidden: { opacity: 0 },
        }}
        className={cn(styles.wrapper, getAlignmentClassName(align_children))}
        ref={ref}
      >
        {columns.map((column, i) => {
          const containsImage = column.find(block => block.type === 'image')
          const className = cn(styles.column, containsImage && styles.columnWithImage)
          return (
            <div key={String(i)} className={className} datatesting="columns_block">
              <motion.div
                animate={containsImage && parallax ? (inView ? 'vis' : 'hid') : false} // eslint-disable-line
                transition={{ type: 'spring', stiffness: 50, friction: 800 }}
                variants={{
                  vis: { y: 0 },
                  hid: { y: 30 },
                }}
              >
                <StreamField blocks={column} isColumn />
              </motion.div>
            </div>
          )
        })}
      </motion.div>
    </Section>
  )
}

export default ColumnsBlock
